import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import {
  HomeCustomSelect,
  HomeCustomTextField,
  CustomTextField,
  CustomSelect,
} from "../../../../utils/Fields";
import {
  checkSession,
  confirmLogin,
  login,
} from "../../../../@redux/Action/Config";
import { useNavigate } from "react-router-dom";

// PayVista - Your Trusted Payment Partner
function ConfirmSigninModal({
  isdCode,
  phone,
  setSigninModal,
  isGreen,
  setCurrentStep,
}) {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const navigate = useNavigate();
  const session = useSelector((state) => state.config.loginRes?.Session);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    // Set focus to the first OTP input when the modal is rendered
    document.getElementById("otp-0")?.focus();
  }, []);

  const handleOtpChange = (e, index) => {
    const newOtp = [...otp];
    const key = e.key;
    const value = e.target.value;

    // Handle Backspace keydown event
    if (key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        // If current input is empty, move focus to previous input and clear it
        newOtp[index - 1] = "";
        document.getElementById(`otp-${index - 1}`).focus();
      } else {
        // Clear the current input
        newOtp[index] = "";
      }
    }
    // Handle numeric input
    else if (/^[0-9]$/.test(value)) {
      newOtp[index] = value;

      // Move focus to the next input if not the last one
      if (index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }

    // Update OTP state after each change
    setOtp(newOtp);
  };

  const handleVerificationSubmit = async (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    if (enteredOtp.length === 6) {
      const body = {
        session: session,
        phone_number: `${isdCode}${phone}`,
        otp: enteredOtp,
      };
      try {
        if (isGreen!==null) {
          console.log("is green true??", isGreen!==null);
          await dispatch(confirmLogin(body, navigate, isGreen));
          await dispatch(checkSession());
          setSigninModal(false);
          setCurrentStep((prev) => prev + 1);
        } else {
          await dispatch(confirmLogin(body, navigate));
          await dispatch(checkSession());
        }
      } catch (error) {
        console.error("Error confirming login:", error);
      }
    } else {
      setError("Please enter the complete 6-digit OTP.");
    }
  };

  return (
    <Modal.Body
      className={`p-4 shadow-sm rounded-4 ${isGreen ? "bg-light" : ""}`}
      style={isGreen ? { backgroundColor: "#e6ffe6" } : {}}
    >
      <div className="d-flex my-3">
        <h2
          className="col-11 text-center ms-3 fw-bold"
          style={isGreen ? { color: "#006400" } : {}}
        >
          Enter Verification Code
        </h2>
        <button
          type="button"
          className="col-1 btn-close"
          onClick={() => setSigninModal(false)}
          style={isGreen ? { color: "#006400" } : {}}
        />
      </div>
      <div className="text-center mb-4">
        <FaUserCircle
          size={60}
          style={isGreen ? { color: "#006400" } : { color: "#FF8800" }}
        />
      </div>
      <form
        onSubmit={handleVerificationSubmit}
        className="d-flex flex-column align-items-center"
      >
        <div className="d-flex justify-content-center mb-3">
          {otp.map((data, index) => (
            <input
              key={index}
              type="text"
              name="otp"
              id={`otp-${index}`}
              maxLength={1}
              value={otp[index]}
              onChange={(e) => handleOtpChange(e, index)}
              onKeyDown={(e) => handleOtpChange(e, index)}
              className="form-control form-control-lg rounded text-center mx-1"
              style={
                isGreen
                  ? {
                      width: "50px", // Increased width
                      height: "60px", // Increased height for better fit
                      fontSize: "26px", // Larger font size for better visibility
                      border: "2px solid #006400",
                      boxShadow: "0 0 5px rgba(0, 100, 0, 0.1)",
                      backgroundColor: "#f0fff0",
                      color: "#006400",
                      padding: "5px", // Added padding for better fit
                      textAlign: "center", // Center the text
                      lineHeight: "1.5", // Line height for vertical centering
                    }
                  : {
                      width: "50px", // Increased width
                      height: "60px", // Increased height for better fit
                      fontSize: "26px", // Larger font size for better visibility
                      border: "2px solid #FFC300",
                      boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
                      padding: "5px", // Added padding for better fit
                      textAlign: "center", // Center the text
                      lineHeight: "1.5", // Line height for vertical centering
                    }
              }
            />
          ))}
        </div>

        <div className="col-12 mt-3">
          <div className="text-center">
            <Button
              variant="primary"
              type="submit"
              className="w-75 btn-lg rounded-4 shadow-sm"
              style={
                isGreen
                  ? {
                      background:
                        "linear-gradient(90deg, #006400 0%, #00FF00 100%)",
                      border: "none",
                    }
                  : {
                      background:
                        "linear-gradient(90deg, #FF8800 0%, #FFC300 100%)",
                      border: "none",
                    }
              }
            >
              Verify
            </Button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

function SigninModal({
  signinModal,
  setSigninModal,
  destination,
  setCurrentStep,
}) {
  const [step, setStep] = useState(1);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    phone: "",
    isdCode: "+91",
  });

  // Reset step to 1 whenever modal is opened
  useEffect(() => {
    if (signinModal) {
      setStep(1);
    }
  }, [signinModal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    const body = {
      phone_number: `${formData.isdCode}${formData.phone}`,
    };
    dispatch(login(body, setStep));
  };

  const isGreen = destination;

  return (
    <Modal
      show={signinModal}
      centered
      className="rounded-4"
      backdrop="static"
      onHide={() => setSigninModal(false)}
    >
      {step === 1 && (
        <Modal.Body
          className={`p-4 shadow-sm rounded-4 ${isGreen ? "bg-light" : ""}`}
          style={isGreen ? { backgroundColor: "#e6ffe6" } : {}}
        >
          <div className="d-flex my-3">
            <h2
              className="col-11 text-center ms-3 fw-bold"
              style={isGreen ? { color: "#006400" } : {}}
            >
              Let's Get you Started
            </h2>
            <button
              type="button"
              className="col-1 btn-close"
              onClick={() => setSigninModal(false)}
              style={isGreen ? { color: "#006400" } : {}}
            />
          </div>
          <div className="text-center mb-4">
            <FaUserCircle
              size={60}
              style={isGreen ? { color: "#006400" } : { color: "#FF8800" }}
            />
          </div>

          <form
            className="d-flex flex-column align-items-center"
            onSubmit={handleLogin}
          >
            <div className="col-12 d-flex gap-2 mb-3 w-75">
              <FormControl className="w-25">
                <InputLabel
                  id="demo-simple-select-label"
                  htmlFor="custom-select"
                  style={isGreen ? { color: "#006400" } : { color: "#FF8800" }}
                >
                  Code
                </InputLabel>
                {isGreen ? (
                  <CustomSelect
                    select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Code"
                    onChange={handleChange}
                    style={{ backgroundColor: "#f0fff0", color: "#006400" }}
                  >
                    <MenuItem value={+91}>+91</MenuItem>
                    <MenuItem value={+41}>+41</MenuItem>
                    <MenuItem value={+1}>+1</MenuItem>
                  </CustomSelect>
                ) : (
                  <HomeCustomSelect
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Code"
                    onChange={handleChange}
                  >
                    <MenuItem value={+91}>+91</MenuItem>
                    <MenuItem value={+41}>+41</MenuItem>
                    <MenuItem value={+1}>+1</MenuItem>
                  </HomeCustomSelect>
                )}
              </FormControl>
              {isGreen ? (
                <CustomTextField
                  id="outlined-basic"
                  type="number"
                  className="w-75"
                  name="phone"
                  onChange={handleChange}
                  label="Mobile"
                  variant="outlined"
                  style={{ backgroundColor: "#f0fff0", color: "#006400" }}
                />
              ) : (
                <HomeCustomTextField
                  id="outlined-basic"
                  type="number"
                  className="w-75"
                  name="phone"
                  onChange={handleChange}
                  label="Mobile"
                  variant="outlined"
                />
              )}
            </div>
            <div className="col-12 mt-3">
              <div className="text-center">
                <Button
                  variant="primary"
                  type="submit"
                  className="w-75 btn-lg rounded-4 shadow-sm"
                  style={
                    isGreen
                      ? {
                          background:
                            "linear-gradient(90deg, #006400 0%, #00FF00 100%)",
                          border: "none",
                        }
                      : {
                          background:
                            "linear-gradient(90deg, #FF8800 0%, #FFC300 100%)",
                          border: "none",
                        }
                  }
                >
                  Get In
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      )}
      {step === 2 && (
        <ConfirmSigninModal
          isdCode={formData.isdCode}
          phone={formData.phone}
          setSigninModal={setSigninModal}
          isGreen={isGreen}
          setCurrentStep={setCurrentStep}
        />
      )}
    </Modal>
  );
}

export default SigninModal;
